import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnInit,
    ViewEncapsulation,
} from "@angular/core";
import { S25Util } from "../../../util/s25-util";
import { ModalInterface } from "../modal.interface";
import { UserprefService } from "../../../services/userpref.service";
import { PreferenceService } from "../../../services/preference.service";
import { Preference } from "../../../pojo/PeferenceI";
import prefData = Preference.prefData;
import { ModalHeaderI } from "../modal.header.component";

@Component({
    template: `
        @if (init) {
            <s25-modal-header [data]="data"></s25-modal-header>
            <div class="modal-body">
                <div class="c-margin-top--single c-margin-bottom--single">
                    <div>Preference Time Zone : {{ userPrefTimezone }}</div>
                    <div>Browser Time Zone : {{ userBrowserTimezone }}</div>
                </div>

                <div>
                    Your user preferences and browser time zone settings do not match. You may be viewing events in a
                    different time zone. Please update your preferences to ensure accuracy.
                </div>

                <div class="c-margin-top--single c-margin-bottom--single">
                    Would you like to update your user time zone now?
                    <s25-toggle-button (modelValueChange)="onUpdateTimezone($event)"></s25-toggle-button>
                </div>

                <div class="c-margin-top--single c-margin-bottom--single">
                    To manage your time zone in the future go to
                </div>
                <div>User Settings → Display → Time Zone</div>
            </div>

            <div class="modal-footer">
                <div class="ngCenterAlignText">
                    <div align="right">
                        <button class="aw-button aw-button--primary" (click)="data.closeModal()">Close</button>
                    </div>
                </div>
            </div>
        }
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ModalUserTimezonesComponent implements OnInit, ModalInterface {
    @Input() data: {
        closeModal?: Function;
    } & ModalHeaderI;

    init: boolean = false;
    userBrowserTimezone: string;
    userPrefTimezone: string;
    updated: boolean = false;
    userTimeZoneInit: prefData;

    constructor(
        private elementRef: ElementRef,
        private cd: ChangeDetectorRef,
    ) {
        this.elementRef.nativeElement.angBridge = this; //bridge to AngularJS; used for AngJS to set model values and call setter fns
    }

    async ngOnInit() {
        this.userPrefTimezone = (await UserprefService.getTZName()) ?? undefined;
        this.userBrowserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        this.userTimeZoneInit = await PreferenceService.getPreferences(["Timezone"]);
        this.init = true;
        this.cd.detectChanges();
    }

    async onUpdateTimezone($event: boolean) {
        const S25liveTimeZone = await UserprefService.guessS25LiveTimeZone();
        if ($event && S25liveTimeZone) {
            this.updated = true;
            return PreferenceService.setPreference("Timezone", S25liveTimeZone, "U");
        } else if (this.updated) {
            //reset to originalTimeZone
            return PreferenceService.setPreference("Timezone", this.userTimeZoneInit.Timezone.value, "U");
        }
    }
}
